/* ==========================================================================
   10.TEN — theme behaviour
   Progressive enhancement only. Every page works with JavaScript off.
   ========================================================================== */
(function () {
  "use strict";

  /* ---- mobile nav ------------------------------------------------------- */
  document.querySelectorAll("[data-nav-toggle]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var nav = document.getElementById("site-nav");
      if (!nav) return;
      var open = nav.classList.toggle("header__nav--open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });

  /* ---- product thumbnails ----------------------------------------------- */
  var main = document.getElementById("main-image");
  document.querySelectorAll("[data-thumb]").forEach(function (t) {
    t.addEventListener("click", function () {
      if (!main) return;
      main.src = t.getAttribute("data-full");
      main.removeAttribute("srcset");
    });
  });

  /* ---- slideshow — a fade, nothing else --------------------------------- */
  document.querySelectorAll("[data-slides]").forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll(".slide"));
    var dots = Array.prototype.slice.call(root.querySelectorAll("[data-dot]"));
    if (slides.length < 2) return;
    var i = 0, timer = null;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        if (k === i) s.setAttribute("data-active", "");
        else s.removeAttribute("data-active");
      });
      dots.forEach(function (d, k) { d.setAttribute("aria-current", k === i ? "true" : "false"); });
    }

    dots.forEach(function (d) {
      d.addEventListener("click", function () { show(parseInt(d.getAttribute("data-dot"), 10)); restart(); });
    });
    var prev = root.querySelector("[data-prev]"), next = root.querySelector("[data-next]");
    if (prev) prev.addEventListener("click", function () { show(i - 1); restart(); });
    if (next) next.addEventListener("click", function () { show(i + 1); restart(); });

    function restart() {
      if (timer) clearInterval(timer);
      if (root.getAttribute("data-autoplay") !== "true") return;
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      var secs = parseInt(root.getAttribute("data-interval"), 10) || 7;
      timer = setInterval(function () { show(i + 1); }, secs * 1000);
    }
    restart();
  });

  /* ---- add to cart ------------------------------------------------------
     Confirms with a line of text where you already are. No drawer slides over
     the thing you were looking at.

     The one-per-order cap below is a courtesy, not a security control — a
     determined person can still POST to /cart/add.js directly. For a blemished
     giveaway that is fine; you will see it in the order. Making it real needs
     a server-side Shopify Function.                                          */
  var ONE = document.body.getAttribute("data-limit-one") === "true";

  function paint(cart) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = "Cart (" + cart.item_count + ")";
    });
  }

  document.querySelectorAll("form[action*='/cart/add']").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector("[data-add]");
      var note = form.parentNode.querySelector("[data-add-note]");
      var idField = form.querySelector("[name='id']") || document.getElementById("variant-select");
      var vid = idField ? idField.value : null;
      if (btn) btn.disabled = true;

      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var has = vid && cart.items.some(function (it) { return String(it.variant_id) === String(vid); });
          if (ONE && has) {
            if (note) { note.textContent = "Already in your cart. One per person."; note.hidden = false; }
            return null;
          }
          return fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) })
            .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); });
        })
        .then(function (res) {
          if (btn) btn.disabled = false;
          if (!res) return null;
          if (!res.ok) {
            if (note) { note.textContent = res.data.description || "Not available."; note.hidden = false; }
            return null;
          }
          if (ONE) {
            return fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ id: String(res.data.variant_id || vid), quantity: 1 })
            }).then(function (r) { return r.json(); });
          }
          return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (!cart) return;
          paint(cart);
          if (note) { note.textContent = "In your cart."; note.hidden = false; }
        })
        .catch(function () { if (btn) btn.disabled = false; form.submit(); });
    });
  });

  /* ---- variant select submits its own page ------------------------------ */
  var vs = document.getElementById("variant-select");
  if (vs && !vs.getAttribute("form")) {
    vs.addEventListener("change", function () {
      var u = new URL(window.location.href);
      u.searchParams.set("variant", vs.value);
      window.location.href = u.toString();
    });
  }
})();
